function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* ----------------------------------
Import modules
---------------------------------- */

import DomObserverController from 'domobserverjs';
import Classy from '@meteora-digital/classy';
import ScrollDir from "scrolldir";
import ScrollLocker from './classes/scroll-locker';

/* ----------------------------------
Window Variables
---------------------------------- */

ScrollDir();
window.Classy = Classy;
window.ScrollLocker = new ScrollLocker(document.querySelector('.body'));
window.DomObserver = new DomObserverController();

/* ----------------------------------------------------------------
Global Functions
---------------------------------------------------------------- */

window.ScriptLoader = function () {
  var imports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var evt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'scripts-loaded';
  // Filter imports to only those whose selectors exist in the DOM
  var scriptsToLoad = Object.entries(imports).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      selector = _ref2[0],
      loader = _ref2[1];
    // Ensure valid types
    if (typeof selector !== 'string' || typeof loader !== 'function') return false;
    return document.querySelectorAll(selector).length > 0;
  });

  // For debugging purposes only
  var components = [];
  Promise.all(scriptsToLoad.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      selector = _ref4[0],
      loader = _ref4[1];
    return loader().then(function () {
      return components.push(selector);
    })["catch"](function (error) {
      return console.warn("Error loading script for ".concat(selector, ":"), error);
    });
  })).then(function () {
    return setTimeout(function () {
      return window.dispatchEvent(new Event(evt));
    }, 500);
  });
  return components;
};
window.ReactiveLoader = function () {
  var imports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Store the imported scripts using a Set for uniqueness and faster lookups
  var imported = new Set();

  // Loop through the imports object
  Object.entries(imports).forEach(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      selector = _ref6[0],
      loader = _ref6[1];
    // Ensure valid types
    if (typeof selector !== 'string' || typeof loader !== 'function') return;

    // Observe the DOM for the selector and import the script when it is added
    DomObserver.observe(selector, function () {
      // If the script has already been imported, then return
      if (imported.has(selector)) return;

      // Add the script to the imported set
      imported.add(selector);

      // Try to import the script, if it fails, log the error
      loader().then(function () {
        return window.ReactiveScripts.push(selector);
      })["catch"](function (error) {
        console.warn("Error loading script for ".concat(selector, ":"), error);
      });
    });
  });
};
window.LoadCSS = function (url) {
  // If the link already exists, return
  if (document.querySelector('link[href*="' + url + '"], style[data-src*="' + url + '"]')) return;

  // Fetch the CSS file
  fetch(url, {
    method: 'HEAD'
  }).then(function (response) {
    if (response.ok) {
      // Get the last modified date
      var lastModified = new Date(response.headers.get('Last-Modified')).getTime();
      // Create a new link element
      var link = document.createElement('link');

      // Set the attributes of the link
      link.rel = 'stylesheet';
      link.href = "".concat(url, "?v=").concat(lastModified);

      // Append the link to the head
      document.head.appendChild(link);
    }
  })["catch"](function (error) {
    console.error('Error loading CSS:', error);
  });
};
window.PrettyLog = function () {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  console.log("%c".concat(message), "color: ".concat(window.ThemeColours['--colour-primary-contrast'] || '#0c0c0d', "; background-color: ").concat(window.ThemeColours['--colour-primary'] || '#ffffff', "; font-family: monospace; font-size: 16px; line-height: 2; padding: 2px 6px;"));
};

/* ----------------------------------------------------------------
Import Required Scripts
---------------------------------------------------------------- */

import('javascript/main');